import { Box, styled } from '@material-ui/core';

export const InfoViewImageContainer = styled(Box)(({ theme }) => ({
  maxHeight: '200px',
  overflow: 'auto',
  paddingRight: '0.5rem',
}));
export const MasonryItem = styled(Box)(({ theme }) => ({ width: '100%', height: 'fit-content' }));
